<template>
  <div>
    <v-badge v-if="QTDE_PRODUTOS_PEDIDOS > 0" color="white" overlap class="ml-4">
      <template #badge>
        <span style="color: #000">{{ QTDE_PRODUTOS_PEDIDOS }}</span>
      </template>

      <v-btn color="#A51B32" small dark @click="abrirCarrinho">
        <v-icon left>mdi-truck</v-icon>
        Carrinho
        <ListaOpcoes @atualizarFracionamento="atualizarPedidosFracionados" />
      </v-btn>
    </v-badge>

    <v-dialog
      v-model="dialogPedido"
      fullscreen
      hide-overlay
      persistent
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="#042333" height="56px">
          <v-btn icon dark @click="fecharModalPedido()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-flex xs4>
            <div class="pl-1">
              <div class="d-flex align-center">
                <v-icon color="#FFF">mdi-cart</v-icon>
                <p class="ma-0 ml-1 font-weight-medium font-20">Carrinho de Separação</p>
              </div>

              <p class="ma-0 mt-n1 font-12">Pedido {{ pedido.idpedido }} aberto em {{ pedido.data_emissao }}</p>
            </div>
          </v-flex>

          <v-spacer />

          <div class="d-flex align-center">
            <p class="d-flex ma-0 mt-n1 mx-2 font-16">
              <strong class="mr-1">Total Qtde: </strong>
              <span>{{ COMPUTED_TOTAL_QTDE }}</span>
            </p>

            <p class="d-flex ma-0 mt-n1 mx-2 font-16">
              <strong class="mr-1">Total Peso: </strong>
              <span>{{ COMPUTED_TOTAL_PESO }}</span>
            </p>

            <p class="d-flex ma-0 mt-n1 ml-2 font-16">
              <strong class="mr-1">Total Cubagem: </strong>
              <span>{{ COMPUTED_TOTAL_CUBAGEM }}</span>
            </p>
          </div>
        </v-toolbar>

        <v-tabs v-model="tab" centered>
          <v-tab
            v-for="(item, key) in pedidos"
            :key="key"
            :href="`#tab-${item.idpedido}`"
            @click="pedido = item"
          >
            Pedido #{{ item.idpedido }}
          </v-tab>
        </v-tabs>

        <sys-data-table
          v-model="produtos_selecionados"
          :headers="headers_pedido"
          :items="desserts_pedido"
          item-key="idaux"
          show-select
          :search="searchCarrinho"
          :height="alturaDaJanela - 203"
          :item-height="40"
          :item-class="item => ({'text-red': Number(item.qtde_inicial) !== Number(item.qtde_pedido), 'text-dark-green': item.produto_novo })"
        >
          <template #top>
            <v-toolbar flat color="white" class="ma-0 pa-0">
              <h4 class="ml-n3">
                <v-icon left>mdi-format-list-bulleted-square</v-icon>
                Lista de Produtos
              </h4>

              <v-btn
                color="#000"
                class="vbtn-class pa-5"
                text
                @click="dialog_justificativas_carrinho = true"
              >
                <v-icon class="mr-3">$Notepad</v-icon>
                Justificativas
              </v-btn>

              <v-btn
                v-if="produtos_selecionados.length"
                color="red"
                class="ml-6"
                @click="delMultPedido()"
                dark
                small
              >
                <v-icon left small>mdi-delete</v-icon>
                Remover ({{ produtos_selecionados.length }})
              </v-btn>

              <v-spacer />

              <v-text-field
                v-model="searchCarrinho"
                label="Pesquisar"
                class="mt-6 mr-6"
                clearable
                append-icon="mdi-magnify"
                style="max-width: 450px"
              />

              <FiltrosUniversalAvancado
                :ids_produtos_permitidos="COMPUTED_IDS_PRODUTOS_CARRINHO"
                ocultar_filtros_fixos
                ocultar_filtro_combinados
                @limpar:filtros="limparFiltrosFilial()"
                @update:filtros="buscarPedido(pedido.idpedido)"
              >
                <template #activator="{ on, attrs }">
                  <v-btn
                    color="#1976D2"
                    dark
                    small
                    class="mr-5"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon color="#FFFFFF" size="18">mdi-filter</v-icon>
                    <span class="ml-1">Filtrar Escopo</span>
                  </v-btn>
                </template>

                <template #append.outros_filtros>
                  <DivisorComLegenda legenda="Filiais (DRP)" class="my-4" />

                  <div class="d-flex align-center mt-3">
                    <div class="w-33-porcento pr-2">
                      <SysFilialGrupoAutocomplete
                        v-model="filtros_filial.filiais_origem"
                        label="Filial de Origem"
                        outlined
                        hide-details
                        multiple
                      />
                    </div>

                    <div class="w-33-porcento pr-2">
                      <SysFilialGrupoAutocomplete
                        v-model="filtros_filial.filiais_destino"
                        label="Filial de Destino"
                        outlined
                        hide-details
                        multiple
                      />
                    </div>
                  </div>
                </template>
              </FiltrosUniversalAvancado>

              <v-btn
                color="primary"
                small
                class="mr-5"
                @click="execReportSeparacao(true, 2)"
              >
                <v-icon left>mdi-file-excel</v-icon>
                Relatório Excel
              </v-btn>

              <ExportacaoPedidoNerus
                :pedido="pedido"
                @pedido-exportado="dialogPedido = false;getStatusPedido();"
              />

              <ExportacaoPedidoDunorte
                :pedido="pedido"
                @pedido-exportado="dialogPedido = false;getStatusPedido();"
              />

              <ExportacaoPedidoApiAcal
                :pedido="pedido"
                @pedido-exportado="dialogPedido = false;getStatusPedido();"
              />

              <ExportacaoNativaWinthor
                v-if="configuracaoDRP.drp_exportacao_nativa_winthor"
                :idpedido_systock="Number(pedido.idpedido)"
                content_class="mr-5"
                :apenas_uma_origem_e_um_destino="pedido.filiais_origem && pedido.filiais_origem.length === 1 && pedido.filiais_destino.length === 1"
                @exportado-com-sucesso="dialogPedido = false;getStatusPedido();"
              />

              <ExportacaoPadreCicero
                v-if="configuracaoDRP.exportacao_drp_padre_cicero"
                content_class="mr-5"
                :idpedido_systock="Number(pedido.idpedido)"
                @exportado-com-sucesso="dialogPedido = false; getStatusPedido();"
              />

              <ExportacaoPedidoDrpParaErpWinthor
                v-if="configuracaoDRP.exportacao_winthor_drp === 'S'"
                :pedido="pedido"
                content_class="mr-5"
                @exportacao-realizada-com-sucesso="dialogPedido = false;getStatusPedido();"
              />

              <ExportacaoPedidoCisspoderIntegrim
                v-if="configuracaoDRP.integracao_exportacao_cisspoder_integrim"
                :idpedido_systock="Number(pedido.idpedido)"
                content_class="mr-5"
                @exportado-com-sucesso="dialogPedido = false;getStatusPedido();"
              />

              <ExportacaoPedidoAutomatiza
                v-if="configuracaoDRP.exportacao_automatiza"
                :pedido="pedido"
                content_class="mr-5"
                @pedido-exportado="pedidoExportadoParaProtheus($event)"
              />

              <ExportacaoPedidoCasaTudoSacolao
                v-if="configuracaoDRP.exportacao_casa_tudo_sacolao"
                :idpedido_systock="Number(pedido.idpedido)"
                content_class="mr-5"
                @exportado-com-sucesso="dialogPedido = false;getStatusPedido();"
              />

              <ExportacaoRms :idpedido_systock="Number(pedido.idpedido)" />

              <IncluirPedidoLojaDrp
                v-if="configuracaoDRP.exportacao_protheus_drp === 'S'"
                :pedido="pedido"
                @pedido-exportado="pedidoExportadoParaProtheus($event)"
              />

              <v-btn v-else color="primary" @click="finalizar()" small>
                <h4 style="color: #fff">Finalizar</h4>
              </v-btn>
            </v-toolbar>
          </template>

          <template #header>
            <tr>
              <td :colspan="10" />
              <td :colspan="4" style="border: 1px solid #e1dfdf" class="text-center font-14 font-weight-medium pt-1 text-gray-800 border-b-none">Origem</td>
              <td :colspan="5" style="border: 1px solid #e1dfdf" class="text-center font-14 font-weight-medium pt-1 text-gray-800 border-l-none border-b-none">Destino</td>
            </tr>
          </template>

          <template #item.filial_origem="{item}">
            {{ item.filial_origem }}
          </template>

          <template #item.razao_social="{ item }">
            <p
              class="text-no-wrap ma-0 text-truncate w-100"
              :title="`${item.idfornecedor} - ${item.razao_social}`"
            >
              {{ item.razao_social }}
            </p>
          </template>

          <template #item.peso="{ item }">
            {{ Helpers.formatarValorComCasas(item.peso * item.qtde_pedido) }}
          </template>

          <template #item.filial_destino="{item}">
            {{ item.descricao_hub ? item.descricao_hub : item.filial_destino }}
          </template>

          <template #item.classificacao_popularidade="{item}">
            <span v-if="item.classificacao_popularidade === 'P'">1. Frequência Alta de Saída</span>
            <span v-else-if="item.classificacao_popularidade === 'Q'">2. Frequência Média de Saída</span>
            <span v-else>3. Frequência Baixa de Saída</span>
          </template>

          <template #item.descricao_produto="{item}">
            <div class="d-flex align-center ml-n2">
              <DetalhesProdutoDrp
                :idgrupo="idgrupo"
                :filial_destino="item.filial_destino"
                :filial_origem="item.filial_origem"
                :idproduto="item.idproduto"
                :status_abastecimento="item.filial_destino_eh_cd ? 'DISP DRP' : 'DRP'"
              />

              {{ item.descricao_produto }}
            </div>
          </template>

          <template #item.qtde_pedido_embalagem="{item}">
            <div class="d-flex align-center">
              {{ Helpers.formatarValor(item.qtde_pedido / item.multiplo_dist) }}
            </div>
          </template>

          <template #item.cubagem="{item}">
            <div class="d-flex align-center">
              {{ Helpers.formatarValor(item.cubagem) }}
            </div>
          </template>

          <template #item.qtde_pedido="props" style="cursor: pointer">
            <TextFieldFormatadorDeValor
              v-if="props.item.drp_ativar_edicao_qtde_carrinho"
              v-model="props.item.qtde_pedido"
              hide-details
              dense
              class="text-field-centralizado font-12 w-80 pb-2"
              :maxDigitos="0"
              @focus="ev => ev.target.select()"
              @keypress.enter="alterarQuantidadeDaLinha(props.item)"
              @blur="alterarQuantidadeDaLinha(props.item)"
            />

            <span v-else>{{ Helpers.formatarValor(props.item.qtde_pedido) }}</span>
          </template>

          <template #item.prioridade="{ item }">
            <div class="ma-1">
              <MixSelect
                v-model="item.prioridade"
                :items="prioridadeMixSelect"
                @change="() => atualizarPrioridadeItemCarrinho(item)"
              />
            </div>
          </template>

          <template #item.tipo_justificativa="{item}">
            <div
              v-if="item.tipo_justificativa"
              class="text-truncate text-center font-11 ma-1 pa-1 border-gray-600 bra-10"
            >
              {{ item.tipo_justificativa }}
            </div>
          </template>

          <template #item.justificativa="{ item }">
            <span v-if="!item.justificativa || item.justificativa.length <= 20">
                {{ item.justificativa }}
            </span>

            <Legenda v-else titulo="Legenda" :legenda="item.justificativa">
              {{ item.justificativa.slice(0, 20) }}…
            </Legenda>
          </template>

          <template #item.action="{item}">
            <v-btn icon @click="delItemPedido(item)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>

          <template #footer.prepend>
            <div class="d-flex align-center ml-3">
              <div class="quadrado-15 bg-green"></div>
              <span class="ml-1 font-13">Produto Novo</span>
            </div>
          </template>
        </sys-data-table>
      </v-card>
    </v-dialog>


    <!--Dialog tipo de relatorio-->
    <v-dialog v-model="dialogTipoRelatorio" max-width="450px" content-class="bra-20">
      <v-card>
        <v-card-title>
          <span>Tipo do relatório</span>

          <v-spacer />

          <v-btn icon @click="pedido = {};$emit('update:listagem-produtos', {});dialogTipoRelatorio = false;">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="mt-2">
          <v-select
              v-model="selects.tipoRelatorio.id"
              :items="selects.tipoRelatorio"
              label="Selecione Tipo Relatório"
              outlined
              item-value="id"
              item-text="tipo"
              hide-details
          />
        </v-card-text>

        <v-card-actions>
          <v-spacer />

          <v-btn v-if="fn" color="primary" text @click="execReportSeparacao(true, selects.tipoRelatorio.id)">Gerar</v-btn>
          <v-btn v-else color="primary" text @click="execReportSemSaldo(selects.tipoRelatorio.id)">Gerar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <DialogJustificativasCarrinhoSeparacao
      v-model="dialog_justificativas_carrinho"
      :idpedido="Number(pedido.idpedido)"
      :selecionados="produtos_selecionados"
      @upload:concluido="() => buscarPedido(this.pedido.idpedido)"
    />
  </div>
</template>

<script>
import DrpAPI from "@/api/drp";
import {logout} from "@/helpers";
import DetalhesProdutoDrp from "@/components/drp/separacaoDeMercadorias/DetalhesProduto/Index";
import TextFieldFormatadorDeValor from "@/components/utils/TextFieldFormatadorDeValor.vue";

import ExportacaoPedidoDrpParaErpWinthor from "@/components/drp/separacaoDeMercadorias/ExportacaoParaERP/Winthor/Index";
import ExportacaoPadreCicero from "@/components/drp/separacaoDeMercadorias/ExportacaoParaERP/PadreCicero/Index.vue";
import ExportacaoPedidoCisspoderIntegrim from "@/components/drp/separacaoDeMercadorias/ExportacaoParaERP/CisspoderIntegrim/Index.vue";
import ExportacaoPedidoAutomatiza from "@/components/drp/separacaoDeMercadorias/ExportacaoParaERP/Automatiza/Index.vue";
import ExportacaoNativaWinthor from "@/components/drp/separacaoDeMercadorias/ExportacaoParaERP/NativaWinthor/Index.vue";
import ExportacaoPedidoNerus from "@/components/drp/separacaoDeMercadorias/ExportacaoParaERP/Nerus/Index.vue";
import ExportacaoPedidoApiAcal from "@/components/drp/separacaoDeMercadorias/ExportacaoParaERP/Gemco/Index.vue";
import ExportacaoPedidoCasaTudoSacolao from "@/components/drp/separacaoDeMercadorias/ExportacaoParaERP/CasaTudoSacolao/Index.vue";
import ExportacaoRms from "@/components/drp/separacaoDeMercadorias/ExportacaoParaERP/Rms.vue";
import ExportacaoPedidoDunorte
  from "@/components/drp/separacaoDeMercadorias/ExportacaoParaERP/Dunorte/Index.vue";

import ResponsiveHeight from "@/helpers/ResponsiveHeight";
import IncluirPedidoLojaDrp from "@/components/drp/separacaoDeMercadorias/exportacaoProtheus/IncluirPedidoLojaDrp.vue";
import $axios from "@/api/api";
import Api from "@/api/api";
import Index from "@/components/drp/separacaoDeMercadorias/Carrinho/ListaOpcoes/Index.vue";
import api from "@/api/api";
import FiltrosUniversalAvancado from "@/components/utils/FiltrosUniversalAvancado.vue";
import DivisorComLegenda from "@/components/utils/DivisorComLegenda.vue";
import SysAutocomplete from "@/components/utils/crud/SysAutocomplete.vue";
import SysFilialGrupoAutocomplete from "@/components/utils/crud/SysFilialGrupoAutocomplete.vue";
import MixSelect from "@/components/MixProdutosFilial/componentes/atomos/MixSelect.vue";
import DialogJustificativasCarrinhoSeparacao
  from "@/components/drp/separacaoDeMercadorias/Carrinho/DialogJustificativasCarrinhoSeparacao.vue";
import Legenda from "@/components/produto/detalhes/Legenda.vue";

export default {
  name: "CarrinhoSeparacao",
  mixins: [ResponsiveHeight],
  components: {
    MixSelect,
    SysFilialGrupoAutocomplete,
    SysAutocomplete, DivisorComLegenda,
    FiltrosUniversalAvancado,
    Legenda,
    DialogJustificativasCarrinhoSeparacao,
    ListaOpcoes: Index,
    DetalhesProdutoDrp,
    ExportacaoPedidoDrpParaErpWinthor,
    TextFieldFormatadorDeValor,
    IncluirPedidoLojaDrp,
    ExportacaoPadreCicero,
    ExportacaoPedidoCisspoderIntegrim,
    ExportacaoPedidoAutomatiza,
    ExportacaoNativaWinthor,
    ExportacaoPedidoApiAcal,
    ExportacaoPedidoNerus,
    ExportacaoPedidoCasaTudoSacolao,
    ExportacaoRms,
    ExportacaoPedidoDunorte
  },
  props: ['atualizar_pedidos_carrinho_count', 'configuracaoDRP', 'idgrupo', 'selects'],
  data: () => ({
    tab: null,
    pedidos: [],
    pedido: {},
    fn: false,
    dialogPedido: false,
    dialogTipoRelatorio: false,
    desserts_pedido: [],
    produtos_selecionados: [],
    headers_pedido: [
      { text: "Filial Origem", value: "filial_origem" },
      { text: "Filial Destino", value: "filial_destino" },
      { text: "Tipo Produto", value: "tipo_produto" },
      { text: "Cód. Produto", value: "idproduto" },
      { text: "Cód. Fabricante", value: "cod_produto" },
      { text: "Descrição Produto", value: "descricao_produto" },
      { text: "Fornecedor", value: "razao_social" },
      { text: "UN", value: "unidade_compra" },
      { text: "Peso", value: "peso" },

      { text: "Estoque", title: 'Saldo de Estoque', value: "origem_estoque", is_number: true, style: { borderLeft: '1px solid #e1dfdf'} },
      { text: "Proj. Vendas", title: 'Projeção de Vendas', value: "origem_projecao_venda", is_number: true },
      { text: "Est. Estético", title: 'Estoque Estético', value: "origem_estoque_min", is_number: true },
      { text: "Est. Máximo", title: 'Estoque Máximo', value: "origem_emax", is_number: true, style: { borderRight: '1px solid #e1dfdf'} },

      { text: "Estoque", title: 'Saldo Estoque', value: "destino_estoque", is_number: true },
      { text: "Disp. Trans.", title: 'Estoque Disponível para Transferência', value: "destino_estoque_disponivel", is_number: true },
      { text: "Proj. Vendas", title: 'Projeção de Vendas', value: "destino_projecao_venda", is_number: true },
      { text: "Est. Estético", title: 'Estoque Estético', value: "destino_estoque_min", is_number: true },
      { text: "Est. Máximo", title: 'Estoque Máximo', value: "destino_emax", is_number: true, style: { borderRight: '1px solid #e1dfdf'} },
      { text: "Qtde. Produtos Embalagem", title: 'Qtde. Produtos Embalagem', value: "qtde_pedido_embalagem" },
      { text: "Cubagem", title: 'Cubagem', value: "cubagem" },
      { text: "Qtde. Produtos", title: 'Qtde. Produtos', value: "qtde_pedido" },
      { text: "Prioridade", title: 'Prioridade', value: "prioridade" },

      { text: "Motivo", title: 'Motivo', value: "tipo_justificativa" },
      { text: "Justificativa", title: 'Justificativa', value: "justificativa" },

      { text: "Ações", value: "action" },
    ],
    searchCarrinho: "",
    pedido_finalizado: null,
    prioridadeMixSelect: [
      { label: 'Sim', value: 'S', color: '#0CB97B', icon: '$CheckCircle' },
      { label: 'Não', value: 'N', color: '#E02244', icon: '$XCircle' },
    ],
    ignorar_filtros: [
      'tipos_produtos', 'venda_futura_maior_que_saldo_estoque', 'grupos',
      'fora_de_linha', 'inativo_revenda', 'produto_resgatado'
    ],
    filtros_filial: {
      filiais_origem: [],
      filiais_destino: []
    },
    dialog_justificativas_carrinho: false
  }),
  computed: {
    QTDE_PRODUTOS_PEDIDOS() {
      return this.pedidos.reduce((a, b) => a + Number(b.total_itens), 0);
    },
    COMPUTED_TOTAL_QTDE() {
      return this.Helpers.formatarValorComCasas(this.desserts_pedido.reduce((acumulador, itemAtual) => parseFloat(acumulador) + parseFloat(itemAtual.qtde_inicial), 0));
    },
    COMPUTED_TOTAL_PESO() {
      return this.Helpers.formatarValorComCasas(this.desserts_pedido.reduce((acumulador, itemAtual) => parseFloat(acumulador) + (parseFloat(itemAtual.qtde_pedido) * parseFloat(itemAtual.peso)), 0));
    },
    COMPUTED_TOTAL_CUBAGEM() {
      return this.Helpers.formatarValorComCasas(this.desserts_pedido.reduce((acumulador, itemAtual) => parseFloat(acumulador) + parseFloat(itemAtual.cubagem), 0));
    },
    COMPUTED_IDS_PRODUTOS_CARRINHO() {
      return [...new Set(this.desserts_pedido.map(i => i.idproduto))];
    }
  },
  watch: {
    atualizar_pedidos_carrinho_count() {
      this.buscarPedidos();
    },
    pedido(novo, velho) {
      if (novo.idpedido === velho.idpedido) return;

      if (!this.pedido.idpedido) return;

      if (!this.dialogPedido) return;

      this.tab = `tab-${this.pedido.idpedido}`;
      this.buscarPedido(this.pedido.idpedido);
      this.produtos_selecionados = [];
    }
  },
  mounted() {
    this.buscarPedidos();
  },
  methods: {
    abrirCarrinho() {
      this.dialogPedido = true;
      this.tab = `tab-${this.pedido.idpedido}`;
      this.buscarPedido(this.pedido.idpedido);
    },
    buscarPedidos() {
      const params = {
        iduser: localStorage.getItem("id"),
      };

      api.get("/getStatusPedido_", { params })
        .then(response => {
          this.pedidos = response.data.pedido;

          if (this.pedidos.length > 0) {
            this.pedido = this.pedidos[0];
          } else {
            this.dialogPedido = false;
            this.pedido = {}
            this.desserts_pedido = []
          }
        })
        .catch(logout);
    },
    atualizarPedidos() {
      this.buscarPedidos()
      this.$emit("update:atualizacao-pedido", {});
    },
    buscarPedido(idpedido) {
      const headers = this.Helpers.iniciarRequisicao();
      const filtros_drp =
        Object.fromEntries(
          Object.entries(this.$store.getters["filtrosUniversalAvancado/filtros"])
          .filter(([f]) => !this.ignorar_filtros.includes(f)));

      const params = {
        pedido: idpedido,
        ...filtros_drp,
        filiais_origem: this.filtros_filial.filiais_origem,
        filiais_destino: this.filtros_filial.filiais_destino,
        considerar_produtos_combinacao: true
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        DrpAPI.getPedido(headers, params)
          .then((response) => {
              this.desserts_pedido = response.data.pedido;
          })
          .catch(logout)
      );
    },
    fecharModalPedido() {
      this.dialogPedido = false;
      this.$emit('update:listagem-produtos', {});
    },
    delMultPedido() {
      if (confirm("Deseja remover o Pedido?")) {
        const headers = this.Helpers.iniciarRequisicao();

        const params = [];

        this.produtos_selecionados.forEach((p) => {
          params.push({
            pedido: this.pedido.idpedido,
            filial_origem: p.filial_origem,
            filial_destino: p.filial_destino,
            produto: p.idproduto,
          });
        });

        this.$store.dispatch(
          "loading/addRequisicao",
          DrpAPI.delMultPedido(headers, params)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);

              if (response.status == 200) {
                this.produtos_selecionados = [];
                this.buscarPedido(this.pedido.idpedido);
                this.atualizarPedidos();
              }
            })
            .catch(logout)
        );
      }
    },
    execReportSeparacao(ok, tipo) {
      if (ok) {
        const token = localStorage.getItem("token");
        const usuario = localStorage.getItem("nome");

        const getRotaRelatorio = (tipo) => {
          const urls = [
            { tipo: 1, url: "relatorio_romaneio_drp2" },
            { tipo: 2, url: "relatorio_romaneio_drp2_excel" },
            { tipo: 3, url: "relatorio_romaneio_drp2_csv" },
          ];

          const respota = urls.filter((item) => item.tipo === tipo);

          return respota[0] ? respota[0].url : null;
        };

        const pedidoAtual = this.pedido_finalizado ? this.pedido_finalizado : this.pedido.idpedido;

        const url = getRotaRelatorio(tipo).concat(
          "?systock=grupo&",
          `token=${token}&`,
          `pedido=${pedidoAtual}&`,
          `usuario=${usuario}`
        );

        window.open($axios.defaults.baseURL + "/" + url, "_blank");

        this.dialogTipoRelatorio = false;
        this.$emit('update:listagem-produtos', {});
        this.atualizarPedidos();
        this.fn = false;
        this.pedido_finalizado = null;
      } else {
        this.dialogTipoRelatorio = true;
        this.fn = true;
      }
    },
    getStatusPedido() {
      this.$emit('update:status-pedido');
      this.buscarPedidos();
    },
    pedidoExportadoParaProtheus(execRelatorio) {
      this.desserts_pedido = [];
      this.dialogPedido = false;
      this.$emit('update:exportacao-protheus', execRelatorio);
    },
    finalizar() {
      if (!confirm("Deseja finalizar o Carrinho?")) {
        return;
      }

      const headers = this.Helpers.iniciarRequisicao();
      const iduser = localStorage.getItem("id");

      const params = {
        iduser: iduser,
        pedido: this.pedido.idpedido,
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        DrpAPI.finalizar(headers, params)
          .then(() => {
            if (this.pedidos.length === 1) {
              this.dialogPedido = false;
              this.dialog_filiais_com_estoque_disponivel = false;
              this.execReportSeparacao(false, 0);
              this.pedido_finalizado = this.pedido.idpedido;
            }
          })
          .catch(logout)
          .finally(() => this.atualizarPedidos())
      );
    },
    alterarQuantidadeDaLinha(linha) {
      const parametros = {
        idpedido: linha.idpedido,
        idproduto: linha.idproduto,
        filial_origem: linha.filial_origem,
        filial_destino: linha.filial_destino,
        qtde_pedido: linha.qtde_pedido
      }

      Api.post('drp-grupo/atualizar-qtde-carrinho-separacao-mercadoria', parametros)
        .catch(logout);
    },
    delItemPedido(pedido) {
      if (confirm("Deseja remover o Pedido?")) {
        const headers = this.Helpers.iniciarRequisicao();

        const params = {
          pedido: this.pedido.idpedido,
          filial_origem: pedido.filial_origem,
          filial_destino: pedido.filial_destino,
          produto: pedido.idproduto,
        };

        this.$store.dispatch(
          "loading/addRequisicao",
          DrpAPI.delItemPedido(headers, params)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);

              if (response.status == 200) {
                this.buscarPedido(this.pedido.idpedido);
                this.atualizarPedidos();
              }
            })
            .catch(logout)
        );
      }
    },
    execReportSemSaldo(tipo) {
      if (tipo === 1) {
        const token = localStorage.getItem("token");

        let url =
            "relatorio_romaneio_drp_sem_saldo?systock=grupo&token=" +
            token +
            "&filial=" +
            this.filiaisSelecionadasForceArray +
            "&grupo=" +
            this.selects.grupo.value +
            "&tipo=" +
            this.selects.tipo_abastecimento.value;

        window.open($axios.defaults.baseURL + "/" + url, "_blank");

        this.buscarDrp();
      } else {
        const token = localStorage.getItem("token");

        let url =
            "relatorio_romaneio_drp_sem_saldo_excel?systock=grupo&token=" +
            token +
            "&filial=" +
            this.filiaisSelecionadasForceArray +
            "&grupo=" +
            this.selects.grupo.value +
            "&tipo=" +
            this.selects.tipo_abastecimento.value;

        window.open($axios.defaults.baseURL + "/" + url, "_blank");
      }

      this.dialogTipoRelatorio = false;
    },
    atualizarPrioridadeItemCarrinho(item) {
      const corpo = {
        idpedido: item.idpedido,
        idproduto: item.idproduto,
        filial_origem: item.filial_origem,
        filial_destino: item.filial_destino,
        prioridade: item.prioridade
      }

      api.post('drp-grupo/atualizar-prioridade-carrinho-separacao-mercadoria', corpo)
      .catch(() => {
        alert('Não foi possível atualizar a prioridade');
        logout();
      });
    },
    atualizarPedidosFracionados() {
      this.buscarPedidos();
    },
    limparFiltrosFilial() {
      this.filtros_filial.filiais_origem = [];
      this.filtros_filial.filiais_destino = [];
    }
  }
}
</script>

<style scoped>
.vbtn-class {
  text-transform: none;
  border: 1px solid #DFDFE0;
  padding: 8px 18px 8px 18px;
  border-radius: 6px;
  margin-top: 1px;
  margin-left: 15px;
  font-weight: 500;
}
</style>
